import { Banner, Button } from "@panwds/react-ui";
import { ExternalLinkIcon } from "@panwds/icons";
import { useTranslate } from '../../../customHooks';
import { FC } from 'react';

type BannerType = 'integration-page' | 'add-policy';

interface PanoramaUpgradeBannerProps {
    type?: BannerType;
}

const defaultOptions = {
    strong: (chunks: any) => (<strong>{chunks}</strong>),
    b: (chunks: any) => (<strong>{chunks}</strong>),
}

const PANORAMA_DOCS_URL = "https://live.paloaltonetworks.com/t5/customer-resources/pan-os-globalprotect-amp-user-id-preferred-release-guidance-from/ta-p/258304";

const handleLearnMoreClick = () => {
        try {
            const newWindow = window.open(PANORAMA_DOCS_URL, "_blank");
            if (!newWindow) {
                // Fallback: could show a toast notification or alternative action
                console.warn("Unable to open documentation link");
            } else {
                newWindow.opener = null;
            }
        } catch (error) {
            console.error("Failed to open documentation link:", error);
        }
};

export const PanoramaUpgradeBanner: FC<PanoramaUpgradeBannerProps> = ({ type = 'integration-page' }) => {
    const translate = useTranslate();

    const renderLearnMoreButton = () => (
        <Button
            appearance="clear"
            size="sm"
            onClick={handleLearnMoreClick}>
            {translate('generic.learnMore')}
            <ExternalLinkIcon size="xs" className="tw-pl-2" />
        </Button>
    );

    const renderIntegrationPageContent = () => (
        <div className="tw-flex tw-flex-col tw-gap-1">
            <div>
                {translate('panoramaUpgradeBanner.integrationsPage.line1', defaultOptions)}
            </div>
            <div>
                {translate('panoramaUpgradeBanner.integrationsPage.line2', defaultOptions)}
            </div>
            <div>
                {translate('panoramaUpgradeBanner.integrationsPage.line3', defaultOptions)}
            </div>
        </div>
    );

    const renderAddPolicyContent = () => (
        <div className="tw-flex tw-flex-col tw-gap-1">
            <div>{translate('panoramaUpgradeBanner.addPolicyPanel.line1')}</div>
            <div>{translate('panoramaUpgradeBanner.addPolicyPanel.line2')}</div>
        </div>
    );

    const renderBanner = (content: JSX.Element, showMargin = false) => {
        const banner = (
            <Banner
                type="inline"
                showIcon={true}
                appearance="standard"
                actions={renderLearnMoreButton()}
            >
                {content}
            </Banner>
        );

        return showMargin ? (
            <div className="tw-mb-4">
                {banner}
            </div>
        ) : banner;
    };

    switch (type) {
        case 'integration-page':
            return renderBanner(renderIntegrationPageContent());
        case 'add-policy':
            return renderBanner(renderAddPolicyContent(), true);
        default:
            return null;
    }
};
